module.exports = __webpack_public_path__ + "static/img/msump9.d26b905.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/msump9.png
// module id = Wad8
// module chunks = 0